import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchDowloadDocument,
  fetchViewPatientResultEntryData,
} from "services/resultEntryReportMaster";
import { STALE_TIME } from "utils/constants";

const PatientDocument = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const patientData = location.state?.patientData;
  const investigationId = patientData?.investigation_data?.investigation_id;

  const hasDownloadedRef = useRef(false);

  useQuery(
    ["fetch-view-observation-result-entry"],
    () =>
      fetchViewPatientResultEntryData({
        appointment_id: patientData?.appointment_id,
      }),
    {
      staleTime: STALE_TIME,
      enabled: !!patientData?.appointment_id,
    }
  );

  const { data } = useQuery(
    ["fetch-signature", patientData?.appointment_id, investigationId],
    () =>
      fetchDowloadDocument({
        appointment_id: patientData?.appointment_id,
        investigation_id: investigationId,
      }),
    {
      staleTime: STALE_TIME,
      enabled: !!patientData?.appointment_id && !!investigationId,
    }
  );

  useEffect(() => {
    if (data?.data?.data && !hasDownloadedRef.current) {
      hasDownloadedRef.current = true;
      console.log("*************data*************", data?.data);

      const documents = data.data.data;

      documents.forEach((doc) => {
        if (!doc.file_data) return;

        const ext = (doc.file_name || "").split(".").pop().toLowerCase();
        const mimeMap = {
          pdf: "application/pdf",
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          png: "image/png",
          webp: "image/webp",
        };
        const mimeType = mimeMap[ext] || "application/octet-stream";

        try {
          const byteCharacters = atob(doc.file_data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mimeType });

          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = doc.file_name || "patient_document";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error processing download for", doc.file_name, error);
        }
      });

      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  }, [data, navigate]);

  return null;
};

export default PatientDocument;
